// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1JpV2","avatar":"style_avatar__2OD5t","addpht":"style_addpht__1G46Z","btnContainer":"style_btnContainer__omtRP"};